import React from 'react';
import { Link } from '../../components/ui';
import { Icon } from '@socialchorus/shared-ui-components';
import { trackCreateUGCDraftClick } from '../../models/ugc-draft/analytics';
import { useTranslation } from 'react-i18next';
import './post-creation.scss';

const CreatePostLink = () => {
  const { t } = useTranslation();
  const handleClick = React.useCallback(() => {
    trackCreateUGCDraftClick();
  }, []);

  return (
    <Link
      className="create-post-link"
      href="/post/new"
      action="push"
      onClick={handleClick}
      aria-label={t('nav_links.create_post')}
    >
      <Icon>edit</Icon>
    </Link>
  );
};

export default CreatePostLink;
